module.exports = __webpack_public_path__ + "static/media/guide_Page_06.186ae96d.png";